import AutorenewRoundedIcon from '@mui/icons-material/AutorenewRounded';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded';
import TimelineRoundedIcon from '@mui/icons-material/TimelineRounded';
import {
  Box,
  ClickAwayListener,
  Divider,
  Grow,
  IconButton,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Typography,
} from '@mui/material';
import React from 'react';

// * i18n
import { useTranslation } from 'react-i18next';

const InitiativeKanbanCardActions = ({ onView, onEdit, onDelete, onReset }) => {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const { t } = useTranslation('energyxplorer-initiatives-tab');

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleMenuItemClick = (option) => {
    setOpen(false);
    if (option === 'view') {
      onView();
    }
    if (option === 'edit') {
      onEdit();
    }
    if (option === 'delete') {
      onDelete();
    }
    if (option === 'reset') {
      onReset();
    }
  };
  return (
    <>
      <IconButton onClick={handleToggle} size="small" ref={anchorRef}>
        <MoreVertRoundedIcon fontSize="small" />
      </IconButton>

      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        modifiers={[
          {
            name: 'flip',
            options: { fallbackPlacements: ['top-start', 'bottom-start'] },
          },
          {
            name: 'preventOverflow',
            options: { altBoundary: true, rootBoundary: 'document' },
          },
        ]}
        style={{ zIndex: 1301 }}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              zIndex: 21302,
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  id="split-button-menu"
                  autoFocusItem
                  dense
                  sx={{ p: 1 }}
                >
                  <MenuItem
                    onClick={() => handleMenuItemClick('view')}
                    sx={{
                      py: '6px',
                      px: '12px',
                      borderRadius: '5px',
                    }}
                  >
                    <Box
                      component="span"
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                      }}
                    >
                      <TimelineRoundedIcon sx={{ mr: 1 }} />
                      <Typography variant="body2" fontWeight="medium">
                        {t('button_labels.show_plot')}
                      </Typography>
                    </Box>
                  </MenuItem>
                  <MenuItem
                    onClick={() => handleMenuItemClick('reset')}
                    sx={{
                      py: '6px',
                      px: '12px',
                      borderRadius: '5px',
                    }}
                  >
                    <Box
                      component="span"
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                      }}
                    >
                      <AutorenewRoundedIcon sx={{ mr: 1 }} />
                      <Typography variant="body2" fontWeight="medium">
                        {t('button_labels.reset_periods')}
                      </Typography>
                    </Box>
                  </MenuItem>
                  <Divider sx={{ my: 0.5 }} />
                  <MenuItem
                    onClick={() => handleMenuItemClick('edit')}
                    sx={{
                      py: '6px',
                      px: '12px',
                      borderRadius: '5px',
                    }}
                  >
                    <Box
                      component="span"
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                      }}
                    >
                      <EditRoundedIcon sx={{ mr: 1 }} />
                      <Typography variant="body2" fontWeight="medium">
                        {t('button_labels.edit')}
                      </Typography>
                    </Box>
                  </MenuItem>
                  <MenuItem
                    onClick={() => handleMenuItemClick('delete')}
                    sx={{
                      py: '6px',
                      px: '12px',
                      borderRadius: '5px',
                    }}
                  >
                    <Box
                      component="span"
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                      }}
                    >
                      <DeleteRoundedIcon sx={{ mr: 1 }} />
                      <Typography variant="body2" fontWeight="medium">
                        {t('button_labels.delete')}
                      </Typography>
                    </Box>
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
};

export default InitiativeKanbanCardActions;
